/**
 * Constantes de Aprendizagem (TCA / TCA Empregador)
 */

import {
  LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK,
} from "./contratos.js";

export { LINK_DOCUSIGN_TCA_CIEEMG_FALLBACK };

export const STATUS_CORES = {
  PENDENTE: "#3b82f6",
  APROVADO: "#1e3a8a",
  RECUSADO: "#dc2626",
};

export const CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA = new Set([
  "nome_social",
  "estado_natal",
  "naturalidade",
  "nacionalidade",
  "data_nascimento",
  "sexo",
  "tipo_sanguineo",
  "cor",
  "fumante",
  "estado_civil",
  "nome_mae",
  "cpf_mae",
  "telefone_mae",
  "email_mae",
  "data_nascimento_mae",
  "naturalidade_mae",
  "estado_civil_mae",
  "logradouro",
  "numero_endereco",
  "complemento",
  "bairro",
  "cep",
  "regiao",
  "cidade",
  "estado_endereco",
  "pais",
  "telefone_02",
  "telefone_01",
  "email_pessoal",
  "nome_aprendiz_menor_idade",
  "telefone_aprendiz_menor_idade",
  "cpf_aprendiz_menor_idade",
  "email_aprendiz_menor_idade",
  "rg_aprendiz_menor_idade",
  "orgao_emissor_aprendiz_menor_idade",
  "profissao_aprendiz_menor_idade",
  "grau_parentesco_aprendiz_menor_idade",
  "grau_instrucao",
  "curso_escolaridade",
  "instituicao_ensino",
  "conclusao",
  "pis",
  "rg",
  "data_emissao_rg",
  "orgao_emissor_rg",
  "estado_rg",
  "titulo_eleitor",
  "zona",
  "secao",
  "data_emissao_titulo",
  "estado_titulo",
  "numero_certificado_reservista",
  "data_emissao_certificado",
  "orgao_expedicao",
  "situacao_militar",
  "banco_pagamento",
  "agencia",
  "conta",
  "qtd_dia_pratica",
  "linha_pratica_ida_1",
  "tarifa_pratica_ida_1",
  "linha_pratica_ida_2",
  "tarifa_pratica_ida_2",
  "linha_pratica_volta_1",
  "tarifa_pratica_volta_1",
  "linha_pratica_volta_2",
  "tarifa_pratica_volta_2",
  "qtd_dia_teorica",
  "linha_teorica_ida__1",
  "tarifa_teorica_ida_1",
  "linha_teorica_ida_2",
  "tarifa_teorica_ida_2",
  "linha_teorica_volta_1",
  "tarifa_teorica_volta_1",
  "linha_teorica_volta_2",
  "tarifa_teorica_volta_2",
  "deseja_vale_transporte",
  "possui_dependentes",
  "nome_declarante_ir",
  "cpf_declarante_ir",
  "estado_civil_ir",
]);

for (let i = 1; i <= 10; i += 1) {
  [
    "nome",
    "cpf",
    "data_nascimento",
    "idade",
    "sexo",
    "grau_parentesco",
    "naturalidade",
  ].forEach((sufixo) => {
    CAMPOS_APRENDIZ_BLOQUEADOS_EMPRESA.add(`dependente_${i}_${sufixo}`);
  });
}
